import axios from "axios"
import { LANDING_PAGES_URL } from "src/constants"

export const getAllLandingPages = async () => {
   return await axios.get(LANDING_PAGES_URL)
}
